// Campanha Inteligente: conta única do desconto exclusivo no painel (Delivery, Pedidos).
// Espelha backend/api/v1/ofertas_dia/desconto.py. `oferta_preco_cheio` tem a
// mesma composição de `preco` (base + adicionais): (cheio − pago) × qtd.

const qtdDoItem = (it) => Number(it?.quantidade ?? it?.quantity ?? it?.qty ?? 1) || 1;

export function precoPagoDoItem(it) {
  return Number(it?.preco_unitario ?? it?.preco ?? it?.price ?? it?.final_price ?? it?.sale_price ?? 0) || 0;
}

export function descontoDoItem(it) {
  if (!it || it.deleted || !it.oferta_preco_cheio) return 0;
  return Math.max(0, Number(it.oferta_preco_cheio) - precoPagoDoItem(it)) * qtdDoItem(it);
}

export function descontoExclusivo(itens) {
  const total = (itens || []).reduce((s, it) => s + descontoDoItem(it), 0);
  return Math.round(total * 100) / 100;
}

// Preço de tabela da linha: o cheio quando o item teve oferta, o pago quando não.
export function precoCheioOuPago(it) {
  return it?.oferta_preco_cheio ? Number(it.oferta_preco_cheio) : precoPagoDoItem(it);
}
